// import { LocalStorage } from 'utils/config'
import { LANGUAGE, LANGUAGE_LIST, EDMODO_USER, SEARCH_KEY } from 'utils/constants'
import { LocalStorage } from 'utils/config'
import { sGetLanguage } from 'apis/edmodo'
export default () => {
  const state = {
    language: {
      language_name: 'English',
      language_code: 'en',
      id: '',
      enable: 1
    },
    language_list: [{
      language_name: 'English',
      language_code: 'en',
      language_id: 1
    }, {
      language_name: '中文',
      language_code: 'zh',
      language_id: 2
    }],
    edmodo_user: {
      id: '',
      type: '',
      username: ''
    },
    searchKey: ''
  }

  const getters = {
    language: state => state.language,
    getLanguageList: state => state.language_list,
    getLanguageId: state => state.language.id,
    getLanguageCode: state => state.language.language_code,
    getEdmodoUserType: state => state.edmodo_user.type,
    getSearchKey: state => state.searchKey
  }

  const mutations = {
    [LANGUAGE] (state, val) {
      state.language = val
    },
    [LANGUAGE_LIST] (state, val) {
      state.language_list = val
    },
    [EDMODO_USER] (state, val) {
      state.edmodo_user = val
    },
    [SEARCH_KEY] (state, val) {
      state.searchKey = val
    }
  }

  const actions = {
    setLanguage ({ commit }, val) {
      commit(LANGUAGE, val)
    },
    asyncSetLanguage ({ commit, state }) {
      sGetLanguage({}).then(res => {
        const { items } = res
        if (items && items.length) {
          commit(LANGUAGE_LIST, items)
          let currentLanguage = LocalStorage.get(LANGUAGE)
          if (currentLanguage) {
            commit(LANGUAGE, currentLanguage)
          } else {
            currentLanguage = items.filter(o => o.language_code === state.language.language_code)
            if (currentLanguage && currentLanguage.length) {
              commit(LANGUAGE, currentLanguage[0])
              LocalStorage.set(LANGUAGE, currentLanguage[0])
            }
          }
        }
      })
    },
    setEdmodoUser ({ commit }, val) {
      commit(EDMODO_USER, val)
    },
    setSearchKey ({ commit }, val) {
      commit(SEARCH_KEY, val)
    }
  }
  return {
    state,
    getters,
    mutations,
    actions
  }
}



// WEBPACK FOOTER //
// ./src/modules/home/create-store.js